const VARIANTS_ENUMS = {
  DEFAULT: "default",
  DESTRUCTIVE: "destructive"
};
export {
  VARIANTS_ENUMS
};
//# sourceMappingURL=constants.mjs.map
